import React from 'react';
import {
  ArrowBackUp,
  Click,
  EmailVerifier,
  Exchange,
  PauseCircle,
  PhoneSignal,
  Send,
} from '@saleshandy/icons';
import OpenedWithBackground from '../components/images/opened-with-background';
import PausedWithBackground from '../components/images/paused-with-background';
import ProspectActivityEmailBouncedColored from '../components/images/prospect-activity-email-bounced-colored';
import ProspectActivityEmailFailedColored from '../components/images/prospect-activity-email-failed-colored';
import ProspectActivityEmailOpenedColored from '../components/images/prospect-activity-email-opened-colored';
import ProspectActivityEmailReceivedColored from '../components/images/prospect-activity-email-reply-colored';
import ProspectActivityEmailSent from '../components/images/prospect-activity-email-sent';
import ProspectActivityEmailUnsubscribedColored from '../components/images/prospect-activity-email-unsubscribed-colored';
import ProspectRemovedFromBlacklistColored from '../components/images/prospect-removed-from-blacklist-colored';
import MasterLog from '../enums/master-log-enum';
import UnsubscribeBan from '../components/images/UnsubscribeBan';
import MarkAsFinishedFlag from '../components/images/MarkAsFinishedFlag';
import ResumedSequencePlay from '../components/images/ResumedSequencePlay';
import PrimaryEmailNumberExchange from '../components/images/PrimaryEmailNumberExchange';
import ColumnFilter from '../components/images/ColumnFilter';
import DeleteActionFilter from '../components/images/DeleteActionFilter';
import SystemUpdateSettings from '../components/images/SystemUpdateSettings';
import MarkAsBouncedIcon from '../components/images/MarkAsBounced';
import Notes from '../components/images/Note';
import EditNote from '../components/images/EditNote';
import CallOutgoing from '../components/images/CallOutgoing';
import CallOutcomeSignal from '../components/images/CallOutcomeSignal';
import PurpleSend from '../components/images/PurpleSend';
import Linkedin from '../components/images/Linkedin';
import OrangeTaskCheckbox from '../components/images/OrangeTaskCheckbox';
import GrayColorAlarm from '../components/images/GrayColorAlarm';
import GreenCircleCheck from '../components/images/GreenCircleCheck';
import PhoneCross from '../components/images/PhoneCross';
import CallIncoming from '../components/images/CallIncoming';
import BlueUserList from '../components/images/BlueUserList';
import BadEmailVerifier from '../components/images/BadEmailVerifier';
import Whatsapp from '../components/images/Whatsapp';
import TaskSkipped from '../components/images/TaskSkipped';
import UserPlus from '../components/images/UserPlus';
import PlayBlueIcon from '../components/images/play-blue';
import BlacklistedRedIcon from '../components/images/BlacklistedRed';
import ProspectPushedSuccess from '../components/images/ProspectPushedSuccess';
import ProspectPushedFailed from '../components/images/ProspectPushedFailed';
import LinkedInAutomationRetryingIcon from '../components/images/LinkedInAutomationRetrying';

// eslint-disable-next-line import/prefer-default-export
export const getActivityIcon = (key: MasterLog) => {
  switch (key) {
    case MasterLog.EmailBounced:
    case MasterLog.EmailBouncedManual:
      return <ProspectActivityEmailBouncedColored />;
    case MasterLog.EmailFailed:
      return <ProspectActivityEmailFailedColored />;
    case MasterLog.EmailOpened:
    case MasterLog.UniboxEmailOpened:
      return <ProspectActivityEmailOpenedColored />;
    case MasterLog.EmailSent:
    case MasterLog.EmailSentManually:
    case MasterLog.UserSentManualEmail:
    case MasterLog.EmailSentOneToOne:
      return <Send width={16} height={16} />;
    case MasterLog.LinkClicked:
      return <Click width={16} height={16} color="#0E7490" />;
    // return <ProspectActivityEmailReceivedColored />;
    case MasterLog.ReplyReceivedAuto:
    case MasterLog.ReplyReceivedManual:
    case MasterLog.ReplyReceived:
      return <ArrowBackUp width={16} height={16} color="#047857" />;
    case MasterLog.UnsubscribedAuto:
    case MasterLog.UnsubscribedManual:
      return <ProspectActivityEmailUnsubscribedColored />;
    case MasterLog.Blacklisted:
      return <BlacklistedRedIcon />;
    case MasterLog.RemovedFromBlacklist:
      return <ProspectRemovedFromBlacklistColored />;
    case MasterLog.MailboxEmailOpened:
      return <OpenedWithBackground />;
    case MasterLog.MailboxEmailLinkClicked:
      return <Click width={16} height={16} color="#8b5cf6" />;
    case MasterLog.SequenceContactPaused:
    case MasterLog.SequenceContactPaused1:
      return <PauseCircle width={16} height={16} color="#B91C1C" />;
    case MasterLog.SequenceContactResumed:
      return <PlayBlueIcon />;
    case MasterLog.UniboxEmailLinkClicked:
      return <Click width={16} height={16} color="#8b5cf6" />;
    case MasterLog.PrimaryEmailChangedAuto:
    case MasterLog.PrimaryEmailChangedManual:
      return <Exchange />;
    case MasterLog.Unsubscribed:
      return <UnsubscribeBan />;
    case MasterLog.MarkAsFinished:
    case MasterLog.FinishedManual:
      return <MarkAsFinishedFlag />;
    case MasterLog.MarkAsReplied:
      return <PurpleSend />;
    case MasterLog.SequencePaused:
      return <PausedWithBackground />;
    case MasterLog.SequenceResumed:
      return <ResumedSequencePlay />;
    case MasterLog.PrimaryEmailNumberChanged:
      return <PrimaryEmailNumberExchange />;
    case MasterLog.MovedColumn:
      return <ColumnFilter />;
    case MasterLog.DeleteNote:
    case MasterLog.NoteDeletedTask:
      return <DeleteActionFilter />;
    case MasterLog.SystemUpdate:
      return <SystemUpdateSettings />;
    case MasterLog.MarkAsBounced:
      return <MarkAsBouncedIcon />;
    case MasterLog.NoteAdded:
    case MasterLog.NoteAddedPrivate:
    case MasterLog.NoteAddedPublic:
    case MasterLog.NoteAddedPrivateTask:
    case MasterLog.NoteAddedPublicTask:
      return <Notes />;
    case MasterLog.NoteEdited:
    case MasterLog.NoteEditedTask:
      return <EditNote />;
    case MasterLog.CallMade:
      return <CallOutgoing />;
    case MasterLog.CallOutcomeChange:
    case MasterLog.CallOutcomeChangeForCallTask:
      return <CallOutcomeSignal />;
    case MasterLog.EmailSentAutomatically:
      return <PurpleSend />;
    case MasterLog.LinkedinTaskCreated:
      return <Linkedin />;
    case MasterLog.CallTaskCreated:
      return <PhoneSignal />;
    case MasterLog.WhatsappTaskCreated:
      return <Whatsapp />;
    case MasterLog.CustomTaskCreated:
      return <OrangeTaskCheckbox />;
    case MasterLog.TaskSnoozed:
    case MasterLog.TaskSnoozedFromProspectTab:
      return <GrayColorAlarm />;
    case MasterLog.TaskSkipped:
    case MasterLog.TaskSkippedFromProspectTab:
    case MasterLog.LinkedInAutomationTaskSkipped:
      return <TaskSkipped />;
    case MasterLog.TaskCompleted:
    case MasterLog.TaskCompletedFromProspectTab:
      return <GreenCircleCheck />;
    case MasterLog.MissCall:
      return <PhoneCross />;
    case MasterLog.OutgoingCall:
      return <CallOutgoing />;
    case MasterLog.IncomingCall:
      return <CallIncoming />;
    case MasterLog.ProfileFieldUpdated:
    case MasterLog.BulkProfileFieldUpdated:
    case MasterLog.ProspectAdded:
      return <BlueUserList />;
    case MasterLog.Resubscribed:
      return <UserPlus />;
    case MasterLog.EmailVerifier:
    case MasterLog.ProspectEmailVerification:
      return <EmailVerifier width={16} height={16} />;
    case MasterLog.BadEmailVerifier:
      return <BadEmailVerifier />;
    case MasterLog.AddToSequence:
      return <Send width={16} height={16} />;
    case MasterLog.LinkedInAutomationExecuted:
    case MasterLog.LinkedInAutomationExecutedRetry:
    case MasterLog.LinkedInAutomationPushed:
    case MasterLog.LinkedInAutomationTaskCompleted:
      return <ProspectPushedSuccess />;
    case MasterLog.LinkedInAutomationRetrying:
      return <LinkedInAutomationRetryingIcon />;
    case MasterLog.LinkedInAutomationFailed:
    case MasterLog.LinkedInAutomationRetryFailed:
    case MasterLog.LinkedInAutomationTaskFailed:
      return <ProspectPushedFailed />;
    default:
      return <ProspectActivityEmailSent />;
  }
};
